import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { LayoutSplashScreen } from '../../_metronic/layout/core'
const jwt = () => { return JSON.parse(localStorage.getItem('MyToken')); }


export default function Logout() {
	useEffect(() => {
		logout();
	}, [])

	const logout = () => {
		const removeJwt = () => {
			localStorage.removeItem('MyToken');
			window.location.href = process.env.REACT_APP_URL;
			//window.location.reload();
		}
		
		removeJwt(); // Actually call the removeJwt function
	}

	return (
		<>
			{jwt ? <LayoutSplashScreen /> : <Redirect to={{ pathname: '/login' }} />}
		</>
	)
}



